(ns ycweb.app.admin.buying.rangereview.rangereview
  (:require
   [rum.core :as rum]
   [ycweb.app.admin.buying.rangereview.categorylevel]
   [ycweb.app.admin.buying.rangereview.common :as rangecmn]
   [ycweb.app.admin.buying.rangereview.printreview]
   [ycweb.app.admin.buying.rangereview.digitalreview]
   [ycweb.app.admin.buying.rangereview.create]
   [ycweb.app.admin.buying.rangereview.selectproducts]
   [ycweb.app.admin.buying.rangereview.addproduct]
   [ycweb.components.buttons :as buttons]
   [ycweb.components.common :as cmn]
   [ycweb.components.flow :as flow]
   [ycweb.components.headings :as headings]
   [ycweb.components.toaster :as toaster]
   [ycweb.components.transitions :as t]
   [ycweb.util.comms :as comms]
   [ycweb.util.core :as u]
   [ycweb.util.urlstate :as urlstate]))

(rum/defc review-line-item < rum/reactive [app-atom review]
  (let [{:range-review/keys [status]} review
        status-desc (:ent/display-name status)
        status-ident (keyword (name (:db/ident status)))]
    [:tr
     {:class
      (u/bem :row-status
        [(when status-desc
           (get rangecmn/review-status-class status-ident))])}
     [:td.u-min-width-240
      (:ent/display-name review)]
     [:td.u-text-nowrap status-desc]
     [:td.u-text-center
      ;; TODO: Why are we using spans for what should be a hrefs unless the link is disabled?
      [:span
       (merge
         (urlstate/href-props app-atom "rangereview" "category" {:review-uuid (:ent/uuid review)})
         {:class (u/bem :text-link [(when (contains? #{:complete :approved} status-ident) :is-disabled)])}) "Review"]]
     [:td.u-text-center
      [:span {:class (u/bem :text-link [(when (not (contains? #{:complete} status-ident)) :is-disabled)])} "Approve"]]
     [:td.u-text-center
      [:a.text-link
       {:href (str "/api/admin/rangereview/products/" (:ent/uuid review))
        :target "_blank"}
       "Download CSV"]]
     #_[:td.u-text-center
        [:span
         {:class (u/bem :text-link [(when (contains? #{:approved} status-ident) :is-disabled)])
          :on-click #(t/transition-next app-atom :admin.merchandising/rangereview-review-table)} "Edit Setup"]]
     ;; TODO: deleting a category should probably have a confirmation modal?
     #_[:td.u-text-center
        [:span {:class (u/bem :text-link [(when (contains? #{:approved} status-ident) :is-disabled)])} "Delete"]]]))

(rum/defc rangereview-table < rum/reactive [app-atom]
  (let [review-process-cursor (cmn/process-cursor app-atom)
        reviews (cmn/curact review-process-cursor :existing-reviews)]

    [:div
     (headings/heading "Existing reviews"
       {:type :h2
        :size :medium
        :flush true})


   ;; TODO: replace this table with the datatable component :)
     [:table
      {:class (u/bem :oTable [:has-shadow])}
      [:colgroup
       [:col {:style {:min-width "240px"}}]
       [:col]
       [:col]
       [:col]
       [:col]
       [:col]]
      [:thead
       [:tr
        [:th.u-min-width-240 {:scope "col"} "Review Name"]
        [:th {:scope "col"} "Review Status"]
        [:th {:scope "col"}]
        [:th {:scope "col"}]
        [:th {:scope "col"} "Export"]
        #_[:th {:scope "col"}]
        #_[:th {:scope "col"}]]]
      [:tbody
       (map (partial review-line-item app-atom) reviews)]]]))

(rum/defc rangereview < rum/reactive [app-atom]
  [:div.admin-react-wrapper__content
   (headings/heading "Product range review"
     {:type :h1
      :size :large})
   [:div.u-max-width-240.u-margin-top-32.u-margin-bottom-32
    (buttons/button-web "Create new review"
      (merge
        (urlstate/href-props app-atom "rangereview" "create")
        {:style :primary
         :size :default
         :full true
         :icon :plus}))]
   (rangereview-table app-atom)
   (toaster/loading-overlay app-atom :admin.rangereview)])

(defmethod t/transition-open :admin.rangereview [app-atom _ params]
  (toaster/open-overlay app-atom :admin.rangereview)
  (comms/send :admin.rangereview/reviews {}))


(defmethod comms/receive :admin.rangereview/reviews [app-atom e]
  (swap! (cmn/process-cursor app-atom) assoc
    :existing-reviews (:reviews e))
  (toaster/close-overlay app-atom :admin.rangereview))

(defmethod flow/render-screen :admin.rangereview [app-atom _]
  (rangereview app-atom))



